import React from 'react';
import { observer } from 'mobx-react';

import { FileField } from 'libs/forms/views/fieldTypes/file';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { Cropper } from 'apps/components/cropper';
import TagsList from 'apps/project/views/tagsList';
import {
  ImageStyled,
  MainSectionWrapper,
  ProjectImageWrapper,
} from 'apps/project/views/projectImage.styles';
import { themes } from 'styles/themes/wikifactoryNew';

type ProjectImageProps = {
  app: Record<string, any>;
  formStore: Record<string, any>;
  fieldName: string;
};

export const ProjectImage = observer(
  ({ app, formStore, fieldName }: ProjectImageProps) => {
    return (
      <MainSectionWrapper
        data-testid='project-image'
        style={{ border: `1px solid #eee` }}
      >
        <TagsList
          app={app}
          buttonDataTestId='project-skills-button'
          wrapperDataTestId='project-skills-wrapper'
        />
        {app.editing ? (
          <FileField
            dataTestId='project-image-input'
            editComponent={ProjectImageWrapper}
            previewComponent={Cropper}
            fieldStore={formStore.fieldStores.get(fieldName)}
          />
        ) : (
          <ImageStyled
            src={imageSrc(
              app[fieldName],
              app.getImageFallbackPath(app.private),
              mainConf.imgSizes.project.large,
            )}
            alt={app.name}
          />
        )}
      </MainSectionWrapper>
    );
  },
);
